

import { Injectable, Inject } from '@angular/core';
import { Observable, of, combineLatest, onErrorResumeNext, Subject } from 'rxjs';
// tslint:disable-next-line: max-line-length
import { DwMdFormActionHandler, DwMdFormActionState, DwMdFormActionResult, DwFormAction, DwSecuritySSOService, DwSecurityRepositoryServiceToken, DwSecurityRepositoryService, DwSecurityUserService, DwMdFormContextInfo, DwOrmDataService, DwOrmDataServiceToken, DwMdFormInitActionHandler, DwMdFormInitActionState } from '@devwareapps/devware-cap';
import { map, flatMap, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

/*import { ConfigService } from 'src/environments/environment';
import { FormGroup } from '@angular/forms';
import { WachterUserExt } from 'src/app/shared/models/wachter-user.model';
import { AppPermissions } from 'src/app/meta-data/app-permissions.enum';*/


@DwFormAction({
  name: 'Save MOR',
  actionKey : 'save2',
  actionMessage: 'Approving...',
  parentItemName : 'MemoOfRecord',
  useDi: true,
  buttonConfig : {
    buttonText : 'Save',
    buttonTitle : 'Save',
    command : 'save2',
    iconClass : '',
    buttonClass : 'btn btn-success'
  }
})
@Injectable({
  providedIn: 'root'
})
export class MorSaveActionService implements DwMdFormActionHandler, DwMdFormInitActionHandler  {
  private static readonly WACHTER_EMPLOYEE_TYPE = 78;
  private static readonly SUBCONTRACTOR_EMPLOYEE_TYPE = 81;

   constructor(
     protected msalHandler: DwSecuritySSOService,
      protected securityService: DwSecurityUserService,
     @Inject(DwSecurityRepositoryServiceToken) protected securityRepository: DwSecurityRepositoryService,
     @Inject(DwOrmDataServiceToken) protected ormDataService: DwOrmDataService,
     protected http: HttpClient) {
  }

  /**
   * Initialize the action to customize any config items
   * @param formInitActionState form state
   */
  initAction(formInitActionState: DwMdFormInitActionState) {
    return;
  }

  handleAction(formActionState: DwMdFormActionState): Observable<DwMdFormActionResult> {
    const result: DwMdFormActionResult = {
      success : true,
      message : 'Saved!',
    };
    const fieldNotFilledOut: DwMdFormActionResult = {
      success : false,
      message : 'Please fill out the Employee field.',
    };

   /*  const wachterUser = this.securityService.securityContext.ApplicationUser.Permissions;
    let CurrentUserTrustId = 0;
    this.securityService.securityContext.ApplicationUser.ExtendedAttributes.forEach(x => {
      if (x.AttrName = 'TrustUserId'){
        CurrentUserTrustId = x.AttrValue;
      }
    });

    if (formActionState.formApi.getFormData().StatusAssignedToEthos_UserId != CurrentUserTrustId){ */

    if (!this.isEmployeeFilledOut(formActionState)) {
      return of (fieldNotFilledOut);
    }

    if (formActionState.formApi.getFormData().StatusCV == null){
    formActionState.formApi.patchFormData({StatusCv: 194})
    }

    this.resetEmployeeFieldsOnTypeChange(formActionState);
    
    const ob = formActionState.formApi.saveData(false)
      .pipe(flatMap(saveResult => {
          if (!saveResult.success) {
            return of(saveResult);
          }
          return of(result);
      }));

      return ob;
  }

  protected resetEmployeeFieldsOnTypeChange(formActionState: DwMdFormActionState) {
    const newMemoOfRecordState = formActionState.formApi.getFormData();
    if (newMemoOfRecordState.EmployeeTypeCv == MorSaveActionService.WACHTER_EMPLOYEE_TYPE) {
      formActionState.formApi.formGroup.get('Ethos_SubcontractorBranchId').setValue(null);
      formActionState.formApi.formGroup.get('EmployeeName').setValue(null);
    }
    else if (newMemoOfRecordState.EmployeeTypeCv == MorSaveActionService.SUBCONTRACTOR_EMPLOYEE_TYPE ){
      formActionState.formApi.formGroup.get('EmployeeEthos_UserId').setValue(null);
    }
  }

   /**
   * Determines if the user can approve/reject the request
   * @param formActionState form state
   */
  protected isEmployeeFilledOut(formActionState: DwMdFormActionState): boolean {


    const memoOfRecord: any = formActionState.formApi.getFormData();

    if (memoOfRecord.EmployeeTypeCv == 78) {
      if (memoOfRecord.EmployeeEthos_UserId != null) {
      return true;
      }
    } else {
      if (memoOfRecord.Ethos_SubcontractorBranchId != null && (memoOfRecord.EmployeeName != '' || memoOfRecord.EmployeeName != null)) {
      return true;
      }
    }

    return false;
  }
}
